// extracted by mini-css-extract-plugin
module.exports = {"feedbackButton":"styles-module--feedbackButton--2erBf"};